import { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { companyActions } from "../../store/actions/company/company.actions";

const DynamicTitleProvider = ({ children, companyActions, companyReducer, companyId }) => {
  useEffect(() => {
    if (!companyId) {
      companyActions.resetCompany();
      return;
    }
    getCompanyDetails();
  }, [companyId]);

  useEffect(() => {
    let name;
    if (companyReducer.company) name = companyReducer.company.name;
    else name = "Advice Ev";

    let title = `${name} - טעינת רכבים חשמליים`;

    document.title = title;
  }, [companyReducer.company]);

  const getCompanyDetails = async () => {
    await companyActions.getCompany(companyId);
  };

  return <>{children}</>;
};

const mapStateToProps = (state) => ({
  companyReducer: state.companyReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    companyActions: bindActionCreators(companyActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicTitleProvider);
